import axios from 'axios';
import global from '@/global'
import {
    Message,
    Loading
} from 'element-ui';

const baseURL = global.host + "/api/";

const ajax = axios.create({
    baseURL,
});
//请求拦截
ajax.interceptors.request.use(req => {

    req.headers.Authorization = 'Bearer ' + (sessionStorage.getItem('token') || '')

    return req
});
//响应拦截
ajax.interceptors.response.use(res => {
    if (res.data.type == "application/octet-stream") {

        return res;
    }
    if (res.data.Code == "1" || res.data.Code == "200") {
        return res.data;
    } else {
        let msg = res.data.Result || res.data.Msg;
        Message.error({
            message: msg
        });
        return Promise.reject(res.data);
    }

}, error => {

    if (error && error.response && error.response.status) {
        handlerError(error.response.status, error.response.data)
    } else {
        Message.error({
            message: '数据请求错误'
        });
    }
    return Promise.reject(error);
});
const handlerError = (status, data) => {
    switch (status) {
        case 401: //授权失效
            sessionStorage.clear();
            window.location.reload();
            break;
        case 500:
            Message.error({
                message: '服务器错误'
            });
            break;

        default:
            Message.error({
                message: '服务器响应错误'
            })
            break;

    }
}
const get = function (url, params = {}) {
    let loadingInstance = null;
    let time = setTimeout(() => {
        loadingInstance = Loading.service({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
    }, 500);
    //去掉空值
    for (let key in params) {
        if (params[key] === '') {
            delete params[key]
        }
    }

    return ajax.get(url, {
        params: params
    }).then(r => r).finally(() => {
        clearTimeout(time);
        if (loadingInstance) {
            loadingInstance.close();
        }

    })
}
const post = function (url, params = {}) {
    let loadingInstance = null;
    let time = setTimeout(() => {
        loadingInstance = Loading.service({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
    }, 500);
    return ajax.post(url, {
        ...params
    }).then(r => r).finally(() => {
        clearTimeout(time);
        if (loadingInstance) {
            loadingInstance.close();
        }
    })
}
const put = function (url, params = {}) {
    let loadingInstance = null;
    let time = setTimeout(() => {
        loadingInstance = Loading.service({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
    }, 500);
    return ajax.put(url, {
        ...params
    }).then(r => r).finally(() => {
        clearTimeout(time);
        if (loadingInstance) {
            loadingInstance.close();
        }
    })
}
const dele = function (url, data = {}) {
    let loadingInstance = null;
    let time = setTimeout(() => {
        loadingInstance = Loading.service({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
    }, 500);

    return ajax.delete(url, {
        data: data
    }).then(r => r).finally(() => {
        clearTimeout(time);
        if (loadingInstance) {
            loadingInstance.close();
        }

    })
}
const download = function (url, params) {
    ajax({
        url,
        params,
        responseType: 'blob'
    }).then(r => {

        let time = this.$dayjs().format("YYYYMMDDHHmmss");

        let fileName = r.headers;
        // 将二进制流转为blob
        let blob = new Blob([r.data], {
            type: 'application/octet-stream'
        })
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
            window.navigator.msSaveBlob(blob, decodeURI(fileName))
        } else {
            // 创建新的URL并指向File对象或者Blob对象的地址
            let blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            let tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', params.FileName + time + ".xlsx")
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        }

    });
}
export default {
    get,
    post,
    put,
    dele,
    download
}